export const padLeft = (s, c, nb) => {
  let result = s;

  while (result.length < nb) {
    result = c + result;
  }

  return result;
}
